import { PersonaItem, returnedPeopleItem, priorityWorkspaceItem } from "../../../types/priorityContacts";

export const truncateString = (str: string, n: number): string => {
  return str.length > n ? str.slice(0, n - 1) + "..." : str;
};

export const mapResponsePeople = (peopleFromResponse: returnedPeopleItem[]): PersonaItem[] => {
  return peopleFromResponse.map((person): PersonaItem => {
    return {
      text: person.displayName,
      secondaryText: person.address,
      showSecondaryText: true,
      tertiaryText: person.address,
    };
  });
};

export const mapResponseWorkspace = (workspaceFromResponse: priorityWorkspaceItem[]): PersonaItem[] => {
  return workspaceFromResponse.map((workspace): PersonaItem => {
    return {
      text: workspace.workspaceName,
      optionalText: workspace.workspaceId,
      primaryText: workspace.workspaceName,
      tertiaryText: workspace.database,
    };
  });
};

export const removeDuplicates = (items: PersonaItem[], existing: PersonaItem[]): PersonaItem[] => {
  return items.filter((item) => !listContainsPersona(item, existing));
};

export const listContainsPersona = (item: PersonaItem, items: PersonaItem[]): boolean => {
  if (!items || items.length === 0) {
    return false;
  }
  return items.some((i) => i.text === item.text);
};
